import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditCompaniesSharedListPayload } from '@app-store/slices/sharedLists/editCompanies'

interface TaskAction extends Action {
    payload: IEditCompaniesSharedListPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.sharedLists.editCompanies

function* editCompaniesSharedListSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.patch(`/companies/shared-lists/select/${payload.sharedListId}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editCompaniesSharedListSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editCompaniesSharedListSagaTask)
}

export default editCompaniesSharedListSaga
